module.exports = __webpack_public_path__ + "img/img_4649.548b2bf0.jpg";